var _templateObject = _taggedTemplateLiteralLoose(['\n  font-size: 11px;\n  line-height: 15px;\n  margin-bottom: 0.5rem;\n  font-weight: normal;\n  font-family: ', ';\n  text-transform: uppercase;\n  color: ', ';\n  text-align: ', ';\n'], ['\n  font-size: 11px;\n  line-height: 15px;\n  margin-bottom: 0.5rem;\n  font-weight: normal;\n  font-family: ', ';\n  text-transform: uppercase;\n  color: ', ';\n  text-align: ', ';\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
var Text = styled.h1(_templateObject, function (props) {
  return props.theme.font_body;
}, function (props) {
  return props.theme.colours.neutral.dark;
}, function (props) {
  return props.align ? props.align : 'left';
});

var Eyebrow = function Eyebrow(props) {
  return React.createElement(Text, {
    align: props.align
  }, props.children);
};

export default Eyebrow;